export default __webpack_public_path__ + "media/images/mailer-new/heading/2fa-recovery-f398862e491cb9399ee2fa8072553cb3.png";